<template>
  <div>
    <p class="pass-step-description">
      {{ passDetail.company_name }} would like you to review agreements.
    </p>

    <div v-if="!isPreview" class="pass-step-review">
      <ul>
        <li v-for="d in passDetail.agreements_data" :key="d.id">
          <p class="agreement-name" v-if="d.other_agreement_name !== 'none'">
            {{ d.other_agreement_name }} -
            <a target="_blank" :href="getAgreementLink(d.ref_code)" class="simple-link agreement-link">
              VIEW
            </a>
          </p>
          <p class="agreement-name" v-else>
            {{ d.agreement_name }} - 
            <a target="_blank" :href="getAgreementLink(d.ref_code)" class="simple-link agreement-link">
              VIEW
            </a>
          </p>
        </li>

        <li v-if="isToVerifyIdentity">
          <p class="agreement-name">Identification card</p>
          <p class="pass-step-description">
            Your id card will be shared to {{ passDetail.company_name }}
            in case any security concerns arises.
            <br>More details
            <a href="#">here</a>
          </p>
        </li>
      </ul>

      <div v-if="!didAgree" class="d-flex flex-row step-cta">
        <button
          @click="updateFunc()"
          class="btn btn-primary pass-step-primary-btn step-cta-row"
          type="button">
          I agree
        </button>
        <a v-bind:href="stepInquiryQuestion" class="step-cta-row simple-link">
          I have some questions.
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import '@/assets/styles/pass-share-steps.css'

export default {
  name: 'step-review-agreements',
  data() {
    return {}
  },
  props: {
    passDetail: {
      type: Object,
      required: true
    },
    isToVerifyIdentity: {
      type: Boolean,
      required: true,
      default: true
    },
    stepInquiryQuestion: String,
    updateFunc: Function,
    isPreview: Boolean,
    didAgree: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    getAgreementLink(link) {
      const url = `${window.location.origin}/agreements/view/${link}`
      return url
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/containers/share/passes/PassShareStepReview.vue